import classnames from 'classnames';

import type { Preference, SubscriberPreferenceOption } from '@/signupElement/Signup.types';

import { checkboxStyle, labelStyle } from '../../Signup.css';

interface Props {
  option: SubscriberPreferenceOption;
  preferenceId: string;
}

const MultipleChoiceInput = ({ option, preferenceId }: Props) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '6px',
        alignItems: 'center',
      }}
    >
      <input
        id={option.id}
        name={`field_${preferenceId}_option_${option.id}`}
        value={option.value}
        className={classnames(checkboxStyle)}
        type="checkbox"
        defaultChecked={false}
      />
      <label htmlFor={option.id} className={classnames(labelStyle)}>
        {option.value}
      </label>
    </div>
  );
};

interface MultipleChoiceProps {
  preference: Preference;
}

const MultipleChoice = ({ preference }: MultipleChoiceProps) => {
  return (
    <fieldset className="flex flex-col gap-2">
      <legend className={classnames('text-left w-full', labelStyle)}>
        {preference?.name}
        {preference?.required && <span>*</span>}
      </legend>
      <div className="flex flex-col gap-1">
        {preference?.subscriber_preference_options.map((option: SubscriberPreferenceOption) => {
          return <MultipleChoiceInput key={option.id} option={option} preferenceId={preference?.id} />;
        })}
      </div>
    </fieldset>
  );
};

export default MultipleChoice;
